import React, { useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'

import { Chip, useTheme, Avatar, Tooltip } from '@mui/material'
import { ReactComponent as MoneyCheckDollarPenIcon } from 'assets/MoneyCheckDollarPen.svg'

import AddEditPurchaseOrderDialog from 'components/work-order/purchase-order/AddEditPurchaseOrderDialog'

const PurchaseOrderChip = ({ workOrderId, serviceDate = '', configuredServiceId = '', purchaseOrder = '', onSuccess = noop }) => {
  const theme = useTheme()
  const [isOpenAddEditPurchaseOrderDialog, setIsOpenAddEditPurchaseOrderDialog] = useState(false)

  const handleAddEditPOClick = () => setIsOpenAddEditPurchaseOrderDialog(true)

  const handleAddEditPOClose = () => setIsOpenAddEditPurchaseOrderDialog(false)

  return (
    <>
      <Tooltip title={purchaseOrder}>
        <Chip
          onClick={handleAddEditPOClick}
          size="small"
          avatar={
            <Avatar sx={{ backgroundColor: 'background.paper', border: '1px solid', borderColor: 'action.disabled' }}>
              <MoneyCheckDollarPenIcon width={14} height={14} />
            </Avatar>
          }
          label={purchaseOrder}
          variant="outlined"
          sx={{ ...theme.typography.subtitle1, fontWeight: 500 }}
        />
      </Tooltip>
      <AddEditPurchaseOrderDialog
        isOpen={isOpenAddEditPurchaseOrderDialog}
        workOrderId={workOrderId}
        serviceDate={serviceDate}
        configuredServiceId={configuredServiceId}
        existingPurchaseOrder={purchaseOrder}
        onClose={handleAddEditPOClose}
        onSuccess={onSuccess}
      />
    </>
  )
}

PurchaseOrderChip.propTypes = {
  workOrderId: PropTypes.string.isRequired,
  serviceDate: PropTypes.string,
  configuredServiceId: PropTypes.string,
  purchaseOrder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSuccess: PropTypes.func,
}

export default PurchaseOrderChip
